export default "__VITE_ASSET__99eb07be__"